/**
 * Extracts the YouTube video ID from a URL.
 * Supports various YouTube URL formats including shorts, share links, and embed links.
 */
export const getYouTubeId = (url: string): string | null => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

/**
 * Converts a YouTube URL to an embeddable format.
 * If the URL is not a YouTube URL or ID cannot be extracted, returns the original URL.
 * Adds autoplay=1 and rel=0 params for better UX in modals/overlays.
 */
export const getEmbedSrc = (url: string): string => {
  const id = getYouTubeId(url);
  if (id) {
    return `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
  }
  return url;
};
